import React, { useState, useEffect } from "react";
import style from "./Homepage.module.css"; // Import the CSS module
import facts from "./birthdayFacts.json"; // Import the JSON file

const BirthdayFact = () => {
  const [fact, setFact] = useState('');

  useEffect(() => {
    const randomFact = facts[Math.floor(Math.random() * facts.length)];
    setFact(randomFact);
  }, []);

  return (
    <div className={style.factText}>{fact}</div>
  );
};

export default BirthdayFact;